/**
 * chat-i18n — shared i18n instance for all chat Preact components.
 *
 * Usage:
 *   import { t } from '../chat-i18n.js'
 *   t('chat.messages.empty')
 */

import { I18n } from 'i18n-js'
import locales from '../../locales.json'

const i18n = new I18n(locales)
i18n.locale = document.querySelector("meta[name='locale']")?.content || 'hu'

export function t(key, opts) {
  return i18n.t(key, opts)
}
